import React from 'react';
import PageLayout from '../common/page-layout/PageLayout';
import { AnkiGuide } from '../common/anki-guide/AnkiGuide';
import { useAuth } from '@/app/context/AuthContext/useAuth';
import Image from 'next/legacy/image';
import { useAnalytics } from '@/app/context/AnalyticsContext/useAnalytics';

import ankiIcon from 'public/anki-icon.png';
import { PageSEO } from '../common/blog/elements/SEO';

export const AnkiPracticeTests = () => {
  const { accessKey, user } = useAuth();

  const { trackEvent, analyticsInstance } = useAnalytics();
  return (
    <PageLayout>
      <PageSEO
        title={'Anki Practice Test Generator'}
        description={'Generate practice tests in Limbiks directly from Anki'}
      />
      <div className="pt-24">
        <div className="flex min-h-screen flex-col justify-center bg-gray-50 py-12 pt-24 sm:px-6 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-md">
            <span className="w-full">
              Anki Add-on
              <div className="flex justify-center">
                <div className="h-16 w-16">
                  <Image src={ankiIcon} alt="Anki-Addon-logo" />
                </div>
              </div>
            </span>

            <h2 className="mt-6 text-center text-3xl font-extrabold leading-9 text-gray-900">
              Practice Test Generator
            </h2>
            <h3 className="mt-2 text-center text-2xl font-extrabold leading-9 text-gray-700">
              Anki Add-on
            </h3>
            <p className="mt-6 text-center text-sm leading-5 text-gray-900">
              Instantly generate practice tests from any Anki deck
            </p>
          </div>

          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">
              <ul className="ml-7 list-disc text-sm font-medium leading-5 text-gray-700">
                <li>Supports both basic and cloze decks</li>
                <li>Create tests with up to 100 questions</li>
                <li>Tests become available instantly in Limbiks</li>
              </ul>

              <div className="mt-6">
                <a
                  onClick={() => {
                    trackEvent(
                      analyticsInstance,
                      'anki_practice_click_download'
                    );
                  }}
                  className="focus:shadow-outline-indigo flex w-full justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-base-content transition duration-150 ease-in-out"
                  href="https://ankiweb.net/shared/info/1881090326"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download the Anki Addon
                </a>
              </div>
              <p className="mt-6 text-center text-sm leading-5 text-gray-900">
                or use code{' '}
              </p>
              <div className="mt-6 rounded bg-gray-200 p-2 text-center text-gray-700 shadow">
                1881090326
              </div>
            </div>
            {accessKey && user && (
              <div className="mt-4 text-center text-sm text-black">
                Your Limbiks Key is{' '}
                <span className="font-bold">{accessKey}</span>
              </div>
            )}
          </div>
        </div>
      </div>

      <AnkiGuide />
    </PageLayout>
  );
};
